module.exports = __webpack_public_path__ + "img/home-about.e6d4c920.png";